// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1dI6i","title":"InfoRow_title__2zZ0g"};